var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 3.39307C7.52676 3.39307 3.12012 7.81944 3.12012 13.3173V20.0396H22.8801V13.3173C22.8801 7.81944 18.4734 3.39307 13.0001 3.39307Z",
    stroke: "#606F8D",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.09985 20.0396H24.8998",
    stroke: "#606F8D",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7248 26.8745C14.8723 26.4695 15.4781 25.218 15.0777 24.0793C14.6773 22.9406 13.4225 22.3459 12.2749 22.751C11.1273 23.156 10.5216 24.4074 10.922 25.5461C11.3223 26.6848 12.5772 27.2795 13.7248 26.8745Z",
    fill: "white",
    stroke: "#2CA1FD",
    strokeWidth: 2.00001
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 27.9998,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon_notification.b073a9d5ef3ce3ab482a326dea495485.svg";
export { ForwardRef as ReactComponent };